<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="false"
      :ableSearch="ableSearch"
    ></search-form>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :customRow="handleRow"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'image'">
          <a-image
            :width="55"
            :src="record.small_image_url"
            :preview="{
              src: record.image_url,
            }"
          />
        </template>
        <template v-else-if="column.key === 'device_name'">
          <span>{{ record.device?.name || '-' }}</span>
        </template>
        <template v-else-if="column.key === 'license_image'">
<!--          <a-image :width="55" :src="record.license_plate_url" />-->
          <a-image :width="55" :src="record.image_url" />
        </template>
        <template v-if="column.key === 'vehicle_type_id'">
          {{ codeToText(record.vehicle_type_id, Enum.carModel.value) }}
        </template>
        <table_data_format
          v-else
          :record="record"
          :column="column"
        ></table_data_format>
      </template>
    </a-table>
    
    <!-- 详情对话框 -->
    <a-modal
      v-model:visible="detailModalVisible"
      title="车辆预约记录"
      :width="800"
      :footer="null"
      destroyOnClose
    >
      <action
        :v-if="detailModalVisible"
        @submit="clickOk"
        :editData="detailData"
        :data="tableData"
        idField="car_application_id"
        :disabled="true"
      ></action>
    </a-modal>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import action from './action'
  import { getVehicle as getData, queryCarApplicationRecord } from '@/api/gate_crossing_records'
  import searchForm from '@/components/search_form'
  import dayjs from 'dayjs'
  import { codeToText, constantToOptions } from '@/utils/format'
  import table_data_format from '@/components/table_data_format'
  import { gateCrossingType, gateCrossingState } from '@/utils/common'
  import { message } from 'ant-design-vue'
  //初始化
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'vehicleGateCrosRecords:list')
  )


  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'licensePlate',
      label: '车牌号码',
      'allow-clear': true,
    },
    /*{
      type: 'input',
      field: 'plateColorStr',
      label: '车牌颜色',
      'allow-clear': true,
    },*/
    {
      type: 'input',
      field: 'colorStr',
      label: '车身颜色',
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'deviceIds',
      label: '闸机类型',
      width: '180px',
      // defaultValue: 1,
      // storeOptions: 'gate',
      storeOptions: 'carGate',
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'eventType',
      label: '车辆进出类型',
      width: '80px',
      // defaultValue: 1,
      options: constantToOptions(gateCrossingType),
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'strobeState',
      label: '道闸状态',
      width: '180px',
      // defaultValue: 0,
      options: constantToOptions(gateCrossingState),
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'visitArea',
      storeOptions: 'areaType',
      defaultValue: 3,
      label: '园区类型',
      width: '130px',
    },
    {
      type: 'dateRange',
      startField: 'startDate',
      endField: 'endDate',
      defaultStart: dayjs().format('YYYY-MM-DD'),
      defaultEnd: dayjs().format('YYYY-MM-DD'),
      label: '日期',
      'allowClear': false,
    },
    {
      type: 'select',
      field: 'vehicleTypeId',
      label: '车型',
      storeOptions: 'carModel',
      width: '190px',
      'allowClear': true,
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setGateVehicle', params)
  }

  //2、表格
  const columns = [
    {
      title: '日期',
      dataIndex: 'date',
      key: 'date',
      align: 'left',
    },
    {
      title: '车牌号码',
      dataIndex: 'license_plate',
      key: 'license_plate',
      align: 'left',
    },
    /*{
      title: '车牌颜色',
      key: 'plate_color_str',
      dataIndex: 'plate_color_str',
      align: 'left',
    },*/
    {
      title: '车牌图片',
      key: 'license_image',
      align: 'left',
    },
    {
      title: '品牌',
      key: 'brand_str',
      dataIndex: 'brand_str',
      align: 'left',
    },
    /*{
      title: '车辆类型',
      key: 'vehicle_type_id',
      dataIndex: 'vehicle_type_id',
      align: 'left',
    },*/
    {
      title: '车辆类型',
      key: 'name',
      dataIndex: 'name',
      align: 'left',
      dataInObject: 'vehicleType'
    },
    {
      title: '车辆颜色',
      key: 'color_str',
      dataIndex: 'color_str',
      align: 'left',
    },
    /*{
      title: '图片',
      key: 'image',
      align: 'left',
    },*/
    {
      title: '进出类型',
      dataIndex: 'event_type',
      key: 'crossing_event_type',
      align: 'left',
    },
    {
      title: '设备名称',
      dataIndex: 'device_name',
      key: 'device_name',
      align: 'left',
    },
    /*{
      title: '道闸状态',
      dataIndex: 'strobe_state',
      key: 'crossing_strobe_state',
      align: 'left',
    },*/
    {
      title: '车辆比对结果',
      dataIndex: 'carCompareResult',
      key: 'carCompareResult',
      align: 'left',
      dataInObject: 'detail',
    },
    {
      title: '人脸比对结果',
      dataIndex: 'faceCompareResult',
      key: 'faceCompareResult',
      align: 'left',
      dataInObject: 'detail',
    },
    {
      title: '抓拍时间',
      dataIndex: 'capture_time',
      key: 'capture_time',
      align: 'left',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function clickOk() {
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }

  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation()
        handleRowDblClick(record)
      },
    }
  }
  
  // 2、双击行查看详情
  const detailModalVisible = ref(false)
  const detailData = ref(null)
  const detailLoading = ref(false)
  
  function handleRowDblClick(record) {
    // 从记录中获取所需参数
    const licensePlate = record.license_plate
    const captureTime = record.capture_time
    
    // 调用接口获取详情
    detailLoading.value = true
    detailData.value = null
    
    queryCarApplicationRecord({
      licensePlate,
      captureTime
    }).then(({ data }) => {
      detailLoading.value = false
      if (data) {
        detailData.value = data
        detailModalVisible.value = true
      } else {
        message.warning('未找到相关申请记录')
      }
    }).catch(error => {
      detailLoading.value = false
    })
  }
  
  const cachedSearchParams = computed(() => store.state.search.searchGateVehicle)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })
</script>

<style scoped>
.detail-container {
  max-height: 500px;
  overflow-y: auto;
}

.detail-item {
  display: flex;
  margin-bottom: 16px;
  align-items: center;
}

.label {
  width: 150px;
  text-align: right;
  padding-right: 16px;
  font-weight: bold;
  background-color: #f0f0f0;
  padding: 8px;
  border-radius: 4px 0 0 4px;
}

.value {
  flex: 1;
  padding: 8px;
  border: 1px solid #f0f0f0;
  border-radius: 0 4px 4px 0;
}

h4 {
  margin-top: 24px;
  margin-bottom: 16px;
  padding-bottom: 8px;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
</style>